<template>
  <section>
    <div class='section-inner'>
      <!-- <div class='si-text'> -->
        <!-- <div class='cov-strip'><div class='strip'></div></div> -->
        <div class='si-text-head'>
          <h2>VISI &amp; MISI</h2>
          <!-- <p>RSKJP MELINDA CARDIO VASCULAR CENTER</p> -->
          <!-- <small>Jl. Dr. Cipto No.11, Pasir Kaliki, Kec. Cicendo, Kota Bandung.</small> -->
        </div>

        <div class='si-accordion'>
          <div class='si-accordion-list' v-for='it in items' :key='it.id'>
            <div class='sa-button' @click='toggle(it.id)'>
              <div class='sa-button-text'>{{ it.title }}</div>
              <div class='sa-button-icon'>
                <img src='../../assets/images/icons/chevronnavy.png' alt='' :class='{ rotated: isOpen(it.id) }' />
              </div>
            </div>

            <div class='sa-content' :class='{ open: isOpen(it.id) }' v-html='it.content'></div>
          </div>
        </div>
      <!-- </div> -->

      <!-- <div class='si-image'>
        <img src='../../assets/images/pictures/dr-ellyana.jpg' alt='melinda cvc' />
      </div> -->
    </div>
  </section>
</template>

<script setup>
import { ref } from 'vue'

const openId = ref(null)

function toggle(id) {
  openId.value = openId.value === id ? null : id
}
function isOpen(id) {
  return openId.value === id
}

const items = [
  {
    id: 'vision',
    title: 'Visi',
    content: 'Menjadi rumah sakit khusus jantung dan pembuluh darah pilihan utama khususnya di kota Bandung dan di Jawa Barat pada umumnya dengan mengutamakan keselamatan dan kepuasan pasien.'
  },
  {
    id: 'mission',
    title: 'Misi',
    content: `<ul>
        <li>Memberikan pelayanan kardiovaskular yang bermutu dan berkualitas tinggi</li>
        <li>Meningkatkan akses masyarakat dalam memperoleh pelayanan kesehatan jantung dan pembuluh darah</li>
        <li>Meningkatkan profesionalisme SDM, sarana dan prasarana untuk mendukung mutu pelayanan</li>
        <li>Meningkatkan kecepatan, ketepatan dan efisiensi pelayanan melalui kerja sama dengan instansi pelayanan kesehatan lainnya</li>
      </ul>`
  },
  {
    id: 'motto',
    title: 'Moto',
    content: '<p>&ldquo;We Care Your Heart&rdquo;</p><p>Melinda Cardio Vascular Center menyatakan fokusnya dalam memberikan pelayanan terbaik dalam penanganan penyakit jantung & pembuluh darah. Akan tetapi, motto tersebut tidak hanya mewakili satu fokus rumah sakit. Kami juga berfokus melayani secara profesional dengan pikiran, perasaan, perilaku yang tulus. Karena kami yakin pelayanan yang dilakukan secara total dan sepenuh hati dapat berdampak positif terhadap kesembuhan, jiwa, dan raga pasien.</p>'
  }
]
</script>

<style scoped>
section{
  padding:2.5rem 10%;
  background:var(--cream-bg);
}
.section-inner{
  display:flex;
  flex-direction: column;
  flex-wrap:wrap;
  width:100%;
}
.si-text{
  width:50%;
}
.si-text-head{
  padding-bottom:1rem;
}
.si-text-head h2{
  font-family:poppins;
  font-size:2.625rem;
  font-weight:700;
  color:var(--navy);
  margin:0;
}
.si-text-head p,
.si-text-head small{
  color:var(--navy);
}
.si-accordion{
  width:100%;
}
.si-accordion-list + .si-accordion-list{
  margin-top:1rem;
}
.sa-button{
  display:flex;
  justify-content:space-between;
  align-items:center;
  cursor:pointer;
  font-family:poppins;
  font-size:1.5rem;
  font-weight:700;
  color:var(--navy);
}
.sa-button-icon img{
  max-width:30px;
  transition:transform 0.25s;
}
.sa-button-icon img.rotated{
  transform:rotate(180deg);
}
.sa-content{
  max-height:0;
  overflow:hidden;
  transition:max-height 0.35s ease-in-out;
  color:var(--navy);
}
.sa-content.open{
  max-height:800px;
}
.sa-content ul{
  padding-left:1.5rem;
}
.si-image{
  width:50%;
}
.si-image img{
  width:100%;
}
@media only screen and (max-width:1500px){
  section{padding:2.5rem 5%;}
}
@media only screen and (max-width:750px){
  section{padding:2.5rem 2.5%;}
  .si-text,
  .si-image,
  .si-accordion{width:100%;}
  .si-image{padding-top:1rem;}
}
</style>
